module.exports = __webpack_public_path__ + "static/media/browserActive.5080c9e6.png";